import * as React from 'react';
export const IcLoiteringOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.73 3.32a1 1 0 00-1.46 1.36l6 6.39L8.28 14H6a1 1 0 00-.93.63l-2 5a1 1 0 101.86.74L6.68 16H9a1 1 0 00.95-.68l.86-2.59L12 14v3H9a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 00.73-1.68l-15-16zM11.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM19 9h-2a1 1 0 00-1 1v2.41l.55.59L20 16.68V10a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
